export const PAGE_LEFT = 'Page: Left Sherpany';
export const PAGE_VISIBILITY_CHANGE = 'Page: Visibility Changed';
export const PAGE_VIEW = 'Page: View';

export const GENERAL_AVATAR = 'General: Avatar';
export const GENERAL_LOG_OUT = 'General: Log Out';
export const GENERAL_SWITCH_TO_ATTENDEE = 'General: Switch To Attendee';
export const GENERAL_SWITCH_TO_EDITOR = 'General: Switch To Editor';
export const GENERAL_SWITCH_TO_ADMIN_PORTAL = 'General: Switch To Admin Portal';
export const GENERAL_RESOLUTION_CHANGE = 'General: Resolution Change';
export const GENERAL_COPY = 'General: Copy';
export const GENERAL_PASTE = 'General: Paste';

export const BULK_ACTION_ADD_USER = 'Bulk Action: Add User';
export const BULK_ACTION_ADD_USER_CANCEL = 'Bulk Action: Add User Cancel';
export const BULK_ACTION_ADD_USER_CONFIRM = 'Bulk Action: Add User Confirm';
export const BULK_ACTION_CANCEL = 'Bulk Action: Cancel';
export const BULK_ACTION_CLONE = 'Bulk Action: Clone';
export const BULK_ACTION_CLONE_CANCEL = 'Bulk Action: Clone Cancel';
export const BULK_ACTION_CLONE_CONFIRM = 'Bulk Action: Clone Confirm';
export const BULK_ACTION_DELETE = 'Bulk Action: Delete';
export const BULK_ACTION_DELETE_CANCEL = 'Bulk Action: Delete Cancel';
export const BULK_ACTION_DELETE_CONFIRM = 'Bulk Action: Delete Confirm';
export const BULK_ACTION_DESELECT = 'Bulk Action: Deselect';
export const BULK_ACTION_DESELECT_ALL = 'Bulk Action: Deselect All';
export const BULK_ACTION_SELECT = 'Bulk Action: Select';
export const BULK_ACTION_SELECT_ALL = 'Bulk Action: Select All';

export const MEMBERS_ADD = 'Members: Add';
export const MEMBERS_REMOVE_FROM_GROUP = 'Members: Remove From Group';
export const MEMBERS_ADD_GENDER = 'Members: Add Gender';
export const MEMBERS_ADD_GROUP = 'Members: Add Group';
export const MEMBERS_ADD_GROUP_SAVE = 'Members: Add Group Save';
export const MEMBERS_ADD_PICTURE_DROP = 'Members: Add Picture Drop';
export const MEMBERS_ADD_PICTURE_DROP_CLICK = 'Members: Add Picture Drop Click';
export const MEMBERS_ADD_PICTURE_UPLOAD = 'Members: Add Picture Upload';
export const MEMBERS_ADD_ROLE_SELECTED = 'Members: Add Role Selected';
export const MEMBERS_ADD_TO_GROUP = 'Members: Add To Group';
export const MEMBERS_DELETE_CANCEL = 'Members: Delete Cancel';
export const MEMBERS_DELETE_CONFIRM = 'Members: Delete Confirm';
export const MEMBERS_GROUP_EDIT_SAVE = 'Members: Group Edit Save';
export const MEMBERS_INVITE_DRAFT = 'Members: Invite Draft';

export const MEETING_OPENED = 'Meeting: Opened';
export const MEETING_CREATE_DECISION_CLICKED = 'Meeting: Create Decision For Voting';
export const MEETING_CREATE_DECISION_VISIBLE = 'Meeting: Create Decision For Voting Visible';

export const MEETING_LIST_FILTER_GROUP = 'Meeting List: Filter Group';
export const MEETING_LIST_TIMELINE = 'Meeting List: Timeline';
export const MEETING_LIST_PARTICIPATION = 'Meeting List: Participation';
export const MEETING_LIST_NAME = 'Meeting List: Name';

export const MEETING_SET_VOTE_OPEN = 'Meeting: Set Vote Open';
export const MEETING_SET_VOTE_CONFIRM = 'Meeting: Set Vote Confirm';
export const MEETING_SET_VOTE_CANCEL = 'Meeting: Set Vote Cancel';

export const MEETING_AGENDA_FROM_TEMPLATE = 'Meeting: Agenda From Template';

export const MEETING_INVITATION_DOCUMENT = 'Meeting: Invitation Document Browse';

export const MEETING_DEALLOCATE_DOCUMENT_MODAL_OPEN = 'Meeting: Deallocate Document Modal Open';
export const MEETING_DEALLOCATE_DOCUMENT_MODAL_CANCELLED =
    'Meeting: Deallocate Document Modal Cancelled';
export const MEETING_DEALLOCATE_DOCUMENT_MODAL_SUBMIT = 'Meeting: Deallocate Document Modal Submit';
export const MEETING_DEALLOCATE_DOCUMENT = 'Meeting: Deallocate Document';
export const MEETING_DELETE_DOCUMENT = 'Meeting: Delete Document';

export const MEETING_DOCUMENT_DOWNLOAD = 'Meeting: Document Downloaded';

export const MEETING_INCLUDE_CALENDAR_INVITATION = 'Meeting: Include Calendar Invitation';

export const OUTDATED_DOCUMENTS_CANCEL = 'Outdated Documents: Cancel';
export const OUTDATED_DOCUMENTS_CANCEL_UPLOAD = 'Outdated Documents: Cancel Upload';
export const OUTDATED_DOCUMENTS_COMMENT_CHANGED = 'Outdated Documents: Comment Changed';
export const OUTDATED_DOCUMENTS_DOCUMENT_UPLOADED_BROWSE =
    'Outdated Documents: Document Uploaded Browse';
export const OUTDATED_DOCUMENTS_DOCUMENT_UPLOADED_DRAG_DROP =
    'Outdated Documents: Document Uploaded Drag&Drop';
export const OUTDATED_DOCUMENTS_UPDATE = 'Outdated Documents: Update';

export const SETTINGS_OPENED = 'Settings: Opened';
export const SETTINGS_ENTER_PROFILE_EDIT_MODE = 'Settings: Enter profile edit mode';
export const SETTINGS_PROFILE_SETTINGS_SAVE_BUTTON = 'Settings: Profile settings save button';
export const SETTINGS_PROFILE_SETTINGS_CANCEL_BUTTON = 'Settings: Profile settings cancel button';
export const SETTINGS_MEETING_SETTINGS_EASY_CHECKIN = 'Settings: Meeting settings easy checkin';

export const SETTINGS_FUTURAE_DEVICE_ADDED = 'Settings: Futurae Device Added';
export const SETTINGS_FUTURAE_DEVICE_REMOVED = 'Settings: Futurae Device Removed';
export const SETTINGS_TAB_SELECTED_LOGIN_HISTORY = 'Settings: Tab Selected Login History';
export const SETTINGS_TAB_SELECTED_NOTIFICATIONS = 'Settings: Tab Selected Notifications';
export const SETTINGS_TAB_SELECTED_SECURITY = 'Settings: Tab Selected Security';
export const SETTINGS_TAB_SELECTED_PIONEERS = 'Settings: Tab Selected Pioneers';
export const SETTINGS_TAB_SELECTED_PROFILE = 'Settings: Tab Selected Profile';
export const SETTINGS_TAB_SELECTED_MEETING_SETTINGS = 'Settings: Tab Selected Meeting Settings';
export const SETTINGS_TAB_SELECTED_INTEGRATIONS = 'Settings: Tab Selected Integrations';
export const SETTINGS_NOTIFICATIONS_DAILY_TOGGLE_PRESSED =
    'Settings: Notifications Daily Toggle Pressed';
export const SETTINGS_NOTIFICATIONS_SINGLE_VALUE_CHANGED =
    'Settings: Notifications Single Value Changed';
export const SETTINGS_SECURITY_PASSWORD_CHANGE_CLICKED =
    'Settings: Security Password Change Clicked';
export const SETTINGS_SECURITY_PASSWORD_CHANGE_CANCELED =
    'Settings: Security Password Change Canceled';
export const SETTINGS_SECURITY_PASSWORD_CHANGED = 'Settings: Security Password Changed';
export const SETTINGS_SECURITY_DEVICE_MANAGEMENT_CLICKED =
    'Settings: Security Device Management Clicked';
export const SETTINGS_PIONEERS_ENABLED = 'Settings: Pioneers Enabled';
export const SETTINGS_PIONEERS_DISABLED = 'Settings: Pioneers Disabled';
export const SETTINGS_AMBASSADORS_ENABLED = 'Settings: Ambassadors Enabled';
export const SETTINGS_AMBASSADORS_DISABLED = 'Settings: Ambassadors Disabled';
export const SETTINGS_PIONEERS_REMINDER_CTA = 'Settings: Pioneers Reminder CTA';
export const SETTINGS_PIONEERS_REMINDER_CANCEL = 'Settings: Pioneers Reminder Cancel';

export const LIBRARY_OPENED = 'Library: Opened';
export const LIBRARY_PRIVATE_DOCUMENT_TAB = 'Library: PrivateDocumentsTab';
export const LIBRARY_CORPORATE_DOCUMENT_TAB = 'Library: CorporateDocumentsTab';
export const LIBRARY_DOCUMENT_OPENED = 'Library: Document Opened';
export const LIBRARY_FILTER = 'Library: Filter';
export const LIBRARY_FILTER_REMOVE = 'Library: Filter Remove';
export const LIBRARY_FILTER_CLEAR_ALL = 'Library: Filter Clear All';
export const LIBRARY_FILTER_CLEAR = 'Library: Filter Clear Filter';
export const LIBRARY_SORT_DATE = 'Library: Sort Date';
export const LIBRARY_SORT_TITLE = 'Library: Sort Title';
export const LIBRARY_DOCUMENT_MENU_OPEN = 'Library: Document Menu Open';
export const LIBRARY_DOCUMENT_RENAME = 'Library: Document Rename';
export const LIBRARY_DOCUMENT_FAVORITE = 'Library: Document Favorite';
export const LIBRARY_DOCUMENT_UNFAVORITE = 'Library: Document Unfavorite';
export const LIBRARY_DOCUMENT_UNREAD = 'Library: Document Mark Unread';
export const LIBRARY_DOCUMENT_READ = 'Library: Document Mark Read';
export const LIBRARY_DOCUMENT_LABELS = 'Library: Document Labels';
export const LIBRARY_DOCUMENT_ACCESS = 'Library: Document Manage Access';
export const LIBRARY_DOCUMENT_ACCESS_THREE_DOT_MENU = 'Library: Document Access Three Dot Menu';
export const LIBRARY_DOCUMENT_SECURITY = 'Library: Document Security';
export const LIBRARY_DOCUMENT_CLASSIFICATION = 'Library: Document Classification';
export const LIBRARY_DOCUMENT_DOWNLOAD = 'Library: Document Download';
export const LIBRARY_DOCUMENT_DELETE = 'Library: Document Delete';
export const LIBRARY_DOCUMENT_DELETE_CONFIRM = 'Library: Document Delete Confirm';
export const LIBRARY_DOCUMENT_DELETE_CANCEL = 'Library: Document Delete Cancel';
export const LIBRARY_DOCUMENT_DELETE_ACKNOWLEDGE = 'Library: Document Delete Acknowledge';
export const LIBRARY_LABEL_CREATE = 'Library: Label Create';
export const LIBRARY_LABEL_CREATE_CANCEL = 'Library: Label Create Cancel';
export const LIBRARY_LABEL_CREATE_SAVE = 'Library: Label Create Save';
export const LIBRARY_LABEL_OPEN = 'Library: Label Open';
export const LIBRARY_LABEL_EDIT = 'Library: Label Edit';
export const LIBRARY_LABEL_EDIT_SAVE = 'Library: Label Edit Save';
export const LIBRARY_LABEL_EDIT_CANCEL = 'Library: Label Edit Cancel';
export const LIBRARY_LABEL_DELETE = 'Library: Label Delete';
export const LIBRARY_LABEL_DELETE_ACKNOWLEDGE = 'Library: Label Delete Acknowledge';
export const LIBRARY_LABEL_DELETE_CANCEL = 'Library: Label Delete Cancel';
export const LIBRARY_LABEL_DELETE_CONFIRM = 'Library: Label Delete Confirm';
export const LIBRARY_LABEL_CONFIRM = 'Library: Label Save';
export const LIBRARY_ACCESS_CANCEL = 'Library: Access Cancel';
export const LIBRARY_ACCESS_SAVE = 'Library: Access Save';
export const LIBRARY_SECURITY_CANCEL = 'Library: Security Cancel';
export const LIBRARY_SECURITY_APPLY = 'Library: Security Apply';
export const LIBRARY_BULK_ACTION_SELECT = 'Library: Bulk Action Select';
export const LIBRARY_BULK_ACTION_SHARE = 'Library: Bulk Action Share';
export const LIBRARY_BULK_ACTION_NOTIFY = 'Library: Bulk Action Notify';
export const LIBRARY_BULK_ACTION_NOTIFY_SEND = 'Library: Bulk Action Notify Send';
export const LIBRARY_BULK_ACTION_NOTIFY_HISTORY = 'Library: Bulk Action Notify History';
export const LIBRARY_BULK_ACTION_SECURITY = 'Library: Bulk Action Security';
export const LIBRARY_BULK_ACTION_DELETE = 'Library: Bulk Action Delete';
export const LIBRARY_BULK_ACTION_DELETE_CONFIRM = 'Library: Bulk Action Delete Confirm';
export const LIBRARY_BULK_ACTION_DELETE_ACKNOWLEDGE = 'Library: Bulk Action Delete Acknowledge';
export const LIBRARY_BULK_ACTION_DELETE_CANCEL = 'Library: Bulk Action Delete Cancel';
export const LIBRARY_ADD_DOCUMENT_BUTTON = 'Library: Add Document Button';
export const LIBRARY_BULK_ACTION_SHARE_BUTTON_CLICKED = 'Library: Bulk Action Share Button Clicked';

export const TD_OPENED = 'T&D: Opened';
export const TD_TASKS = 'T&D: Tasks';
export const TD_DECISIONS = 'T&D: Decisions';
export const TD_FILTER_CANCEL = 'T&D: Filter Cancel';
export const TD_FILTER_CLEAR = 'T&D: Filter Clear';
export const TD_CHANGE_STATUS_OPEN = 'T&D: Change Status Open';
export const TD_CHANGE_STATUS_SELECT = 'T&D: Change Status Select';
export const TD_CHANGE_STATUS_DONE = 'T&D: Change Status Done';
export const TD_CHANGE_STATUS_CANCEL = 'T&D: Change Status Cancel';
export const TD_SORT_BY_DATE_ASCENDING = 'T&D: Sort By Date Ascending';
export const TD_SORT_BY_DATE_DESCENDING = 'T&D: Sort By Date Descending';
export const TD_OPEN_MEETING = 'T&D: Open Meeting';
export const TD_DETAILS_OPENED = 'T&D: Details Opened';
export const TD_DETAILS_CLOSE = 'T&D: Details Close';
export const TD_EDIT_SAVED = 'T&D: Edit Saved';
export const TD_FILTER = 'T&D: Filter';
export const TD_DOWNLOAD = 'T&D: Download';
export const TD_FILTER_VISIBILITY_CHANGED = 'T&D: Filter Visibility Changed';
export const TD_MEETINGS_OVERVIEW_OPENED = 'T&D: Meetings Overview Opened';

export const MEETING_IMPORT_TASKS = 'Meeting: Import Tasks';
export const MEETING_TASKS_SELECT = 'Meeting: Tasks Select';
export const MEETING_TASKS_CANCEL = 'Meeting: Tasks Cancel';
export const MEETING_TASKS_IMPORT = 'Meeting: Tasks Import';
export const MEETING_TASKS_EDIT = 'Meeting: Tasks Edit';
export const MEETING_TASKS_MENU = 'Meeting: Tasks Menu';
export const MEETING_TASKS_MENU_EDIT = 'Meeting: Tasks Menu Edit';
export const MEETING_TASKS_MENU_REMOVE = 'Meeting: Tasks Menu Remove';
export const MEETING_TASKS_DETAILS_CLOSE = 'Meeting: Tasks Details Close';

export const SIGNATURE_STORE_CHECKED = 'Digital Signature: Store Signature Checked';
export const SIGNATURE_STORE_UNCHECKED = 'Digital Signature: Store Signature Unchecked';
export const SIGNATURE_DRAW = 'Digital Signature: Draw Signature';
export const SIGNATURE_CANCEL = 'Digital Signature: Cancel Clicked';
export const SIGNATURE_CLEAR = 'Digital Signature: Clear Signature Clicked';
export const SIGNATURE_INSERT = 'Digital Signature: Insert Clicked';
export const SIGNATURE_START_SIGNING = 'Digital Signature: Start Signing';
export const SIGNATURE_FINISH_SIGNING = 'Digital Signature: Finish Signing';
export const SIGNATURE_RESET_SIGNATURE = 'Digital Signature: Reset Signature';
export const SIGNATURE_REQUEST_SIGNATURE = 'Digital Signature: Request Signatures';
export const SIGNATURE_REQUEST_BACK = 'Digital Signature: Back';
export const SIGNATURE_REQUEST_NEXT = 'Digital Signature: Process Next';
export const SIGNATURE_REQUEST_DATE_SET = 'Digital Signature: Due Date Set';
export const SIGNATURE_REQUEST_MESSAGE_SET = 'Digital Signature: Edit message';
export const SIGNATURE_REQUEST_ITEMS_SELECTED = 'Digital Signature: Item Selected';
export const SIGNATURE_REQUEST_ITEMS_DESELECTED = 'Digital Signature: Item Deselected';
export const SIGNATURE_REQUEST_ITEMS_ALL = 'Digital Signature: All Items Selected';
export const SIGNATURE_REQUEST_SIGNERS_SELECTED = 'Digital Signature: Signer Selected';
export const SIGNATURE_REQUEST_SIGNERS_DESELECTED = 'Digital Signature: Signer Deselected';
export const SIGNATURE_REQUEST_SIGNERS_ALL = 'Digital Signature: All Signers Selected';
export const SIGNATURE_REQUEST_ITEMS_CANCEL = 'Digital Signature: Select Items Canceled';
export const SIGNATURE_REQUEST_SIGNERS_CANCEL = 'Digital Signature: Add Signers Canceled';
export const SIGNATURE_REQUEST_COMPLETE_CANCEL = 'Digital Signature: Complete And Send Cancelled';
export const SIGNATURE_REQUEST_START = 'Digital Signature: Process Started';
export const SIGNATURE_REQUEST_IN_PROGRESS_OPENED = 'Digital Signature: In Progress Dialog Opened';
export const SIGNATURE_REQUEST_IN_PROGRESS_CLOSED = 'Digital Signature: In Progress Closed';
export const SIGNATURE_REQUEST_TERMINATE = 'Digital Signature: Terminated';
export const SIGNATURE_REQUEST_TYPE = 'Digital Signature: Type selected';

export const ONBOARD_DOCUMENTS_ANNOTATED = 'Onboard: Annotated document';

export const DOCUMENTS_PAGE_CHANGED = 'PDF: Document Page Changed';
export const DOCUMENTS_ANNOTATION_ADDED = 'PDF: Annotation Added';
export const DOCUMENTS_ANNOTATION_REMOVED = 'PDF: Annotation Removed';
export const DOCUMENTS_ANNOTATION_CHANGED = 'PDF: Annotation Changed';

// ISOM PUBLISHING
export const ISOM_PUBLISH_CANCEL = 'ISoM Publish: Cancel';
export const ISOM_PUBLISH_CONFIRM = 'ISoM Publish: Confirm';

export const CONTRIBUTORS_ADD_CONTRIBUTOR = 'Contributors: Add Contributor';
export const CONTRIBUTORS_ADD_CONTRIBUTOR_CANCEL = 'Contributors: Add Contributor Cancel';
export const CONTRIBUTORS_ADD_CONTRIBUTOR_SEND_REQUEST =
    'Contributors: Add Contributor Send Request';
export const CONTRIBUTORS_ACTION_OPEN = 'Contributors: Action Open';
export const CONTRIBUTORS_ACTION_DELETE = 'Contributors: Action Delete';
export const CONTRIBUTORS_ACTION_DELETE_CANCEL = 'Contributors: Action Delete Cancel';
export const CONTRIBUTORS_ACTION_DELETE_CONFIRM = 'Contributors: Action Delete Confirm';
export const CONTRIBUTORS_ACTION_CLOSE = 'Contributors: Action Close';
export const CONTRIBUTORS_ACTION_CLOSE_CANCEL = 'Contributors: Action Close Cancel';
export const CONTRIBUTORS_ACTION_CLOSE_CONFIRM = 'Contributors: Action Close Confirm';
export const CONTRIBUTORS_ACTION_UPDATE = 'Contributors: Action Update';
export const CONTRIBUTORS_ACTION_UPDATE_CANCEL = 'Contributors: Action Update Cancel';
export const CONTRIBUTORS_ACTION_UPDATE_CONFIRM = 'Contributors: Action Update Confirm';

export const SEARCH_OPENED = 'Search: Opened';
export const SEARCH_CLOSED = 'Search: Closed';
export const SEARCH_CUSTOM_TERM = 'Search: Started Custom Term';
export const SEARCH_TOGGLE_FTS = 'Search: Toggle FTS';
export const SEARCH_TAB_CHANGED = 'Search: Tab Changed';
export const SEARCH_ROOM_SELECTED = 'Search: Filter Room Selected';
export const SEARCH_ROOM_DESELECTED = 'Search: Filter Room Deselected';
export const SEARCH_GROUP_CHANGED = 'Search: Filter Group Changed';
export const SEARCH_RESULT_SELECTED = 'Search: Result Selected';
export const SEARCH_RECENT_SELECTED = 'Search: Started Recent Selected';
export const SEARCH_MEETING_DATE_CHANGED = 'Search: Filter meeting date Changed';
export const SEARCH_MEETING_SHARING_STATUS_CHANGED =
    'Search: Filter meeting sharing status Changed';
export const SEARCH_FILTER_CLEAR_ALL_CLICKED = 'Search: Filter clear all clicked';
export const SEARCH_FILTER_VISIBILITY_CHANGED = 'Search: Filter visibility changed';
export const SEARCH_DOCUMENT_UPLOAD_DATE_CHANGED = 'Search: Filter document upload date Changed';
export const SEARCH_DOCUMENT_LABELS_CHANGED = 'Search: Filter document labels Changed';
export const SEARCH_TASKS_AND_DECISIONS_TYPE_CHANGED =
    'Search: Filter tasks and decisions type Changed';

export const SUPPORT_OPEN = 'Support Panel: Open';
export const SUPPORT_KNOWLEDGE = 'Support Panel: Knowledge Base';
export const SUPPORT_VIDEO = 'Support Panel: Video';
export const SUPPORT_PRODUCT_PORTAL = 'Support Panel: Product Portal';
export const SUPPORT_SHERPANY_STATUS = 'Support Panel: Sherpany Status';
export const SUPPORT_CHAT = 'Support Panel: Chat';
export const SUPPORT_CALL = 'Support Panel: Call';
export const SUPPORT_MAIL = 'Support Panel: Mail';
export const SUPPORT_SET_CHE = 'Support Panel: Access Select CHE';
export const SUPPORT_SET_TIME = 'Support Panel: Access Set Time';
export const SUPPORT_ACCESS_CONFIRM = 'Support Panel: Access Confirm';
export const SUPPORT_ACCESS_CLOSE = 'Support Panel: Access Close';
export const SUPPORT_ACCESS_CHANGE = 'Support Panel: Access Change';
export const SUPPORT_ACCESS_CHANGE_CANCEL = 'Support Panel: Access Change Cancel';
export const SUPPORT_ACCESS_TERMINATE = 'Support Panel: Access Terminate';

export const SMART_LISTS_SELECT_SUGGESTED = 'List: Select Suggested';
export const SMART_LIST_TYPES = {
    CONTRIBUTOR: 'contributor',
    MENTION: 'mention'
};

export const AUTHENTICATION_CHANGE_LANGUAGE = 'Authentication: Change Language';
export const AUTHENTICATION_NEED_HELP = 'Authentication: Need Help';
export const AUTHENTICATION_PRIMARY_FAILED = 'Authentication: Primary Failed';
export const AUTHENTICATION_PRIMARY_RESET = 'Authentication: Primary Reset';
export const AUTHENTICATION_PRIMARY_SUCCESSFUL = 'Authentication: Primary Successful';
export const AUTHENTICATION_SECONDARY_FAILED = 'Authentication: Secondary Failed';
export const AUTHENTICATION_SECONDARY_RESEND = 'Authentication: Secondary Resend';
export const AUTHENTICATION_SECONDARY_SUCCESSFUL = 'Authentication: Secondary Successful';
export const AUTHENTICATION_SECONDARY_SWITCH = 'Authentication: Secondary Switch';
export const AUTHENTICATION_SHOW_PASSWORD = 'Authentication: Show Password';
export const AUTHENTICATION_CONFIRM_NEW_PASSWORD = 'Authentication: Confirm New Password';
export const AUTHENTICATION_SEND_LINK_TO_RESET_PASSWORD =
    'Authentication: Send Link To Reset Password';

export const ATTENDEE_MEETING_OPENED = 'Meeting: Opened';
export const ATTENDEE_MEETING_HIDE_AGENDA = 'Meeting: Hide Agenda';
export const ATTENDEE_MEETING_SHOW_AGENDA = 'Meeting: Show Agenda';
export const ATTENDEE_MEETING_DOCUMENT_OPENED = 'Meeting: Document Opened';
export const ATTENDEE_MEETING_INVITATION_OPENED = 'Meeting: Invitation Opened';
export const ATTENDEE_MEETING_AGENDA_ITEM_OPENED = 'Meeting: Agenda Item Opened';
export const ATTENDEE_MEETING_INVITATION_DOWNLOAD = 'Meeting: Invitation PDF download';
export const ATTENDEE_MEETING_BOARDBOOK_DOWNLOAD = 'Meeting: Boardbook PDF download';
export const ATTENDEE_MEETING_TOGGLE_DOCUMENT_READ = 'Meeting: Toggle Document Read';
export const ATTENDEE_MEETING_TOGGLE_DOCUMENT_UNREAD = 'Meeting: Toggle Document Unread';
export const ATTENDEE_MEETING_WHITEBOARD_OPENED = 'Meeting: Whiteboard Opened';
export const ATTENDEE_MEETING_JOIN_CALL = 'Meeting: Join Call';
export const ATTENDEE_LEAVE_MEETING_BUTTON_CLICK = 'Meeting: Leave Meeting Button Click';

export const ATTENDEE_MEETING_LIST_TIMELINE = 'Meeting List: Timeline';
export const ATTENDEE_MEETING_LIST_FILTER_MORE = 'Meeting List: Filter More';

export const MEETING_END_REMINDER_SHOW = 'Meeting End Reminder: Show';
export const MEETING_END_REMINDER_CLOSE = 'Meeting End Reminder: Close';
export const MEETING_END_REMINDER_GO_TO_FEEDBACK = 'Meeting End Reminder: Go To Feedback';
export const MEETING_END_REMINDER_AUTO_CLOSE = 'Meeting End Reminder: Auto Close';

export const DCR_VOTE_SET = 'DCR: Vote Set';
export const DCR_VOTE_CHANGED = 'DCR: Vote Changed';
export const DCR_DISCUSSION_REQUESTED = 'DCR: Discussion Requested';
export const DCR_SAVE = 'DCR: Save';
export const DCR_CANCEL = 'DCR: Cancel';
export const PRESENTER_MODE_LEAVE_MEETING = 'Presentation: Leave Meeting';
export const PRESENTER_MODE_RECONNECTING = 'Presentation: Reconnecting';
export const PRESENTER_MODE_RECONNECTED = 'Presentation: Reconnected';
export const PRESENTER_MODE_START_PRESENTING = 'Presentation: Start Presenting';
export const PRESENTER_MODE_START_PRESENTING_CONFIRM = 'Presentation: Start Presenting Confirm';
export const PRESENTER_MODE_START_PRESENTING_CANCEL = 'Presentation: Start Presenting Cancel';
export const PRESENTER_MODE_PAUSE_PRESENTATION = 'Presentation: Pause Presentation';
export const PRESENTER_MODE_RESUME_PRESENTATION = 'Presentation: Resume Presentation';
export const PRESENTER_MODE_OPEN_ATTENDEES = 'Presentation: Open Attendees';
export const PRESENTER_MODE_STOP_PRESENTING = 'Presentation: Stop Presenting';

export const ICALENDAR_OPEN = 'iCalendar: Open';
export const ICALENDAR_CANCEL = 'iCalendar: Cancel';
export const ICALENDAR_SUPPORT_CENTER = 'iCalendar: Support Center';
export const ICALENDAR_GENERATE_FEED = 'iCalendar: Generate Feed';
export const ICALENDAR_COPY_LINK = 'iCalendar: Copy Link';
export const ICALENDAR_DISABLE = 'iCalendar: Disable';
export const ICALENDAR_DISABLE_CANCEL = 'iCalendar: Disable Cancel';
export const ICALENDAR_DISABLE_CONFIRM = 'iCalendar: Disable Confirm';

export const GOAL_SURVEY_RESPONSE = 'Goal Survey: Response';
export const GOAL_SURVEY_CANCELED = 'Goal Survey: Cancel';

export const MEETING_FILE_INLINE_EDIT_STARTED = 'Meeting File Inline Edit: Started';
export const MEETING_FILE_INLINE_EDIT_NAME_CHANGED = 'Meeting File Inline Edit: Name changed';
export const MEETING_FILE_INLINE_EDIT_CHANGES_SAVED = 'Meeting File Inline Edit: Changes Saved';

export const REGISTRATION_FLOW_CLICK_ACCEPT_INVITATION =
    'Registration flow: Click accept Invitation';
export const REGISTRATION_FLOW_SET_UP_PASSWORD = 'Registration flow: Set up password';
export const REGISTRATION_FLOW_SELECT_2FA = 'Registration flow: Select 2FA';
export const REGISTRATION_FLOW_CHOOSE_2FA_BACK_BUTTON =
    'Registration flow: Choose 2FA - Back button';
export const REGISTRATION_FLOW_CHOOSE_2FA_SEND_CODE_BUTTON =
    'Registration flow: Choose 2FA - Send code button';
export const REGISTRATION_FLOW_CHOOSE_2FA_VERIFY_BUTTON =
    'Registration flow: Choose 2FA - Verify button';
export const REGISTRATION_FLOW_CHOOSE_2FA_RESEND_BUTTON =
    'Registration flow: Choose 2FA - Resend button';
export const REGISTRATION_FLOW_SUCCESS_MESSAGE = 'Registration flow: Success Message';
export const REGISTRATION_FLOW_CHOOSE_2FA_DOWNLOAD_FUTURAE_NEXT_BUTTON =
    'Registration flow: Choose 2FA - Download futurae next button';
export const REGISTRATION_FLOW_CHOOSE_2FA_OPEN_FUTURAE_NEXT_BUTTON =
    'Registration flow: Choose 2FA - Open futurae next button';
export const REGISTRATION_FLOW_CHOOSE_2FA_FUTURAE_RELOAD_CODE_BUTTON =
    'Registration flow: Choose 2FA - Futurae reload code button';

export const GROUP_MANAGEMENT_DELETE_GROUP = 'Group Management: Delete group';
export const GROUP_MANAGEMENT_REMOVE_MEMBER_CONFIRM = 'Group Management: Remove member confirm';

export const GLOBAL_SEARCH_OPENED = 'Global Search: Opened';
export const MAIN_MENU_TOGGLE_ACTION = 'Main Menu: Expand/collapsed action';
export const MAIN_MENU_RESOURCES_OPENED = 'Resources: Opened';

export const MINUTES_COPILOT_TRANSCRIPTS_BUTTON_CLICKED =
    'Minutes Copilot: Transcripts Panel Button Clicked';
export const MINUTES_COPILOT_UPDATE_PERMISSIONS_BUTTON = 'Minutes Copilot: Manage Permissions';
export const MINUTES_COPILOT_HOW_START_TRANSCRIPT_RECORDING_BUTTON =
    'Minutes Copilot: How To Activate Transcripts';

export const FORMS_OPENED = 'Forms: Opened';
export const FORMS_PREVIEW_OPENED = 'Forms: Preview Opened';
export const FORMS_COPY_LINK = 'Forms: Copy Form Link';
export const FORMS_DOWNLOAD_FILE = 'Forms: Download Excel File';
export const FORMS_OPEN_RESPONDENTS = 'Forms: Open Respondents';
export const FORMS_DELETE_FORM = 'Forms: Delete Form';
export const FORMS_NEW_FORM = 'Forms: New Form';
export const FORMS_NEW_FORM_DETAILS = 'Forms: New Form - Details';
export const FORMS_NEW_FORM_PREVIEW = 'Forms: New Form - Preview';
export const FORMS_NEW_FORM_SUMMARY = 'Forms: New Form - Summary';
export const FORMS_REQUIRED_FIELDS_MISSING = 'Forms: Required Fields Missing';
export const FORMS_LEAVE_WITHOUT_SUBMITTING = 'Forms: Leave without Submitting';
export const ROOM_SETTINGS_INSIGHT = 'Room Settings';

export const TOPIC_HUB_DOCUMENT_DOWNLOAD = 'Topic Hub: Document Download';

export const MINUTES_SHARE_FROM_ROW = 'Meeting: Open share minutes modal from agenda button';
export const MINUTES_BULK_SHARE = 'Meeting: Open shared minutes modal from bulk';
export const MINUTES_SHARE_FROM_EXPANDED =
    'Meeting: Open share minutes modal from expanded agenda item';
export const MINUTES_SHARE_CONFIRM = 'Meeting: Share minutes confirm';
export const MINUTES_SHARE_CLOSE = 'Meeting: Share minutes close';
export const MINUTES_SHARE_CANCEL = 'Meeting: Share minutes cancel';
export const MINUTES_VIEW = 'Meeting: Minutes View';
export const MINUTES_OPENED_VERSION_HISTORY = 'Minutes: Opened version history';
export const MINUTES_CLOSED_VERSION_HISTORY = 'Minutes: Closed version history';
export const MINUTES_VERSION_SELECTED = 'Minutes: Version selected';
export const MINUTES_SAVED_MINUTES = 'Minutes: Saved minutes';
export const MINUTES_CREATE_DECISION = 'Minutes: Create Decision';
export const MINUTES_SECTION_DELETED = 'Minutes: Minutes section deleted';
export const MINUTES_SECTION_CREATED = 'Minutes: Minutes section created';
export const MINUTES_REORDER_SECTIONS = 'Minutes: Reorder minutes sections';
export const MINUTES_TOOLBAR_BUTTON_CLICKED = 'Minutes: Text toolbar clicked';
export const MINUTES_IMAGE_UPLOADED = 'Minutes : Image uploaded';
export const MINUTES_IMAGE_DELETED = 'Minutes: Image deleted';
export const MINUTES_IMAGE_RESIZED = 'Minutes: Image resized';

export const DATASITE_LOGIN_DEMO_SIGNUP = 'DataSite login: Demo sign-up';

export const WELCOME_STRIPE_CTA_CLICKED = 'Welcome-Stripe: CTA clicked';
export const WELCOME_STRIPE_CLOSE_BUTTON_CLICKED = 'Welcome-Stripe: Close button clicked';

export const COPILOT_QUICK_ACTIONS_FIELD_MENU_OPENED = 'Copilot Quick Actions: Field Menu Opened';
export const COPILOT_QUICK_ACTIONS_REPHRASE = 'Copilot Quick Actions: Rephrase';
export const COPILOT_QUICK_ACTIONS_TRANSLATE = 'Copilot Quick Actions: Translate';

export const LOGIN_FUTURAE_NOT_WORKING_CLICKED = 'Login: Futurae not working clicked';
export const LOGIN_TRY_ANOTHER_WAY_CLICKED = 'Login: Try another way clicked';
export const LOGIN_RECEIVE_SMS_CODE_CLICKED = 'Login: Receive SMS code clicked';
export const LOGIN_REQUEST_2FA_RESET_LINK_CLICKED = 'Login: Request 2FA reset link clicked';
export const LOGIN_CONTACT_SUPPORT_CLICKED = 'Login: Contact support clicked';

export const TRIGGER_ME_TEST = 'Test: Trigger me project';

export const DEMO_MEETING_CLICKED = 'Demo Meeting: Clicked';
export const DEMO_MEETING_REMOVED = 'Demo Meeting: Removed';
